<button
  [matMenuTriggerFor]="sessionMenu"
  class="grid items-center grid-flow-col gap-8"
  *ngIf="!loading"
>
  <div class="grid items-center justify-center grid-flow-col gap-4" #user>
    <div
      class="flex flex-col justify-center items-center bg-[#fff6d9] box-border w-9 h-9 rounded-[36px]"
    >
      <ui-headline
        type="h14"
        mobile-type="h14"
        font-weight="bold"
        text-color="neutrals-900"
        [content]="initials"
      />
    </div>
    <div class="flex flex-col justify-start">
      <ui-headline
        *ngIf="fullname"
        type="h12"
        mobile-type="h12"
        font-weight="semibold"
        text-color="neutrals-900"
        [content]="fullname"
      />
      <ui-paragraph
        *ngIf="description"
        type="p10"
        mobile-type="p10"
        text-color="neutrals-600"
        [content]="description"
      />
    </div>
  </div>
</button>

<mat-menu #sessionMenu="matMenu">
  <div class="box-border grid grid-flow-row gap-4 pt-4" *ngIf="session">
    <div class="grid items-center grid-flow-col gap-8 px-5" *ngIf="!loading">
      <div class="grid items-start justify-start grid-flow-col gap-4">
        <div
          class="flex flex-col justify-center items-center bg-[#fff6d9] box-border w-9 h-9 rounded-[36px]"
        >
          <ui-headline
            type="h14"
            mobile-type="h14"
            font-weight="bold"
            text-color="neutrals-900"
            [content]="initials"
          />
        </div>
        <div class="flex flex-col justify-start">
          <ui-headline
            *ngIf="fullname"
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
            [content]="fullname"
          />
          <ui-paragraph
            *ngIf="description"
            type="p10"
            mobile-type="p10"
            text-color="neutrals-600"
            [content]="description"
          />
        </div>
      </div>
    </div>
    <div class="box-border grid grid-flow-row">
      <button (click)="onAutomationsClick()" *ngIf="showAutomations">
        <div
          class="grid grid-flow-col gap-4 items-center box-border px-5 py-4 border-t-neutrals-400 hover:bg-[#F7F9FC]"
        >
          <ui-icon name="group" fill="neutrals-600" m-size="22" size="22" />

          <div class="w-[200px] flex justify-start items-center">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-600"
            >
              Automatizaciones
            </ui-paragraph>
          </div>
        </div>
      </button>
      <button (click)="onAnswersClick()">
        <div
          class="grid grid-flow-col gap-4 items-center box-border px-5 py-4 border-t-neutrals-400 hover:bg-[#F7F9FC]"
        >
          <ui-icon name="edit" fill="neutrals-600" m-size="20" size="20" />

          <div class="w-[200px] flex justify-start items-center">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-600"
            >
              Respuesta rápidas
            </ui-paragraph>
          </div>
        </div>
      </button>
      <button (click)="onArchivesClick()">
        <div
          class="grid grid-flow-col gap-4 items-center box-border px-5 py-4 border-t-neutrals-400 hover:bg-[#F7F9FC]"
        >
          <ui-icon name="archive" fill="neutrals-600" m-size="20" size="20" />

          <div class="w-[200px] flex justify-start items-center">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-600"
            >
              Archivados
            </ui-paragraph>
          </div>
        </div>
      </button>
      <button (click)="$event.stopPropagation()">
        <div
          class="grid grid-flow-col gap-4 items-center box-border px-5 py-4 border-t-neutrals-400 hover:bg-[#F7F9FC]"
        >
          <ui-icon name="user" fill="neutrals-600" m-size="20" size="20" />

          <div
            class="w-[80%] flex justify-start items-center bg-[#EDF4FB] rounded-[12px] py-[5px] px-[15px]"
          >
            <select
              [(ngModel)]="status"
              (change)="onChangeStatus($event)"
              class="bg-[#EDF4FB] w-full focus:outline-none"
            >
              <option value="" disabled selected hidden>
                Seleccionar un status
              </option>
              <option *ngFor="let status of statusTypes" [value]="status.id">
                {{ status.description }}
              </option>
            </select>
          </div>
        </div>
      </button>
      <button (click)="onLogout()">
        <div
          class="grid grid-flow-col items-center gap-4 box-border px-5 py-4 border-t-neutrals-400 hover:bg-[#F7F9FC]"
        >
          <ui-icon name="log-out" fill="neutrals-600" m-size="20" size="20" />

          <div class="w-[200px] flex justify-start items-center">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-600"
            >
              Cerrar Sesión
            </ui-paragraph>
          </div>
        </div>
      </button>
    </div>
  </div>
</mat-menu>
<!-- Loading -->
<div class="grid items-center grid-flow-col gap-8" *ngIf="loading">
  <div class="grid items-center justify-center grid-flow-col gap-4">
    <ngx-skeleton-loader
      count="1"
      appearance="circle"
      [theme]="{ height: '36px', width: '36px', margin: '0px' }"
    />
    <ngx-skeleton-loader
      count="2"
      appearance="line"
      [theme]="{ marginBottom: '2px', width: '100px', display: 'block' }"
    />
  </div>
</div>
